<template>
  <div class="space-y-4">
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Section Title</label>
      <input v-model="localSection.content.title" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-2">Subtitle</label>
      <input v-model="localSection.content.subtitle" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
    </div>

    <div class="space-y-3">
      <div class="flex items-center justify-between">
        <h4 class="text-sm font-semibold text-gray-800">Feature Items</h4>
        <button type="button" class="text-sm text-green-700 font-medium" @click="addItem">+ Add</button>
      </div>
      <div v-for="(item, index) in localSection.content.items" :key="index" class="rounded-lg border border-gray-200 p-3 space-y-2">
        <input v-model="item.title" type="text" placeholder="Title" class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" @input="emitUpdate">
        <textarea v-model="item.description" rows="2" placeholder="Description" class="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm" @input="emitUpdate" />
        <div class="flex items-center gap-2">
          <input v-model="item.icon" type="text" placeholder="Icon name" class="flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm" @input="emitUpdate">
          <button type="button" class="text-red-600 text-sm" @click="removeItem(index)">Remove</button>
        </div>
      </div>
    </div>

    <section-style-fields :section="localSection" @update="applyStyles" />
  </div>
</template>

<script>
import SectionStyleFields from './SectionStyleFields.vue'

export default {
  components: { SectionStyleFields },
  props: { section: { type: Object, required: true } },
  emits: ['update'],
  data() {
    return { localSection: JSON.parse(JSON.stringify(this.section)) }
  },
  watch: {
    section: {
      handler(value) { this.localSection = JSON.parse(JSON.stringify(value)) },
      deep: true,
    },
  },
  methods: {
    emitUpdate() { this.$emit('update', JSON.parse(JSON.stringify(this.localSection))) },
    applyStyles(section) { this.localSection = section; this.emitUpdate() },
    addItem() {
      this.localSection.content.items.push({ title: 'New Feature', description: 'Description', icon: 'tick' })
      this.emitUpdate()
    },
    removeItem(index) {
      this.localSection.content.items.splice(index, 1)
      this.emitUpdate()
    },
  },
}
</script>
